import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";

type EmailVerificationProps = {
  status: "loading" | "success" | "error";
  onSubmit: () => void;
  t: any;
};

const DefaultEmailVerification: React.FC<EmailVerificationProps> = ({
  status,
  onSubmit,
  t,
}) => {
  return (
    <div
      className="vh-100 d-flex align-items-center"
      style={{ background: "white" }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={6}>
            <div className="d-flex flex-column">
              <h5 className="text-center mb-3">
                {t(`emailVerification:${status}.title`)}
              </h5>
              <p className="text-center mb-3">
                {t(`emailVerification:${status}.subtitle`)}
              </p>
              <Button variant="primary" className="m-auto" onClick={onSubmit}>
                {t("resetPassword:button.submit")}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DefaultEmailVerification;
